//import logo from './logo.svg';
import './App.css';
import SupremeWebsite from './SupremeWebsite';

export default function App() {
  return <SupremeWebsite />;
}
